import React from 'react';

import { Button, Tooltip } from 'antd';

import { useFormikContext } from 'formik';
import { PersonalDocumentType } from 'v2/components/Pages/AddBankAccount/Stepper/form';
import type { INewAccount } from 'v2/interfaces/financial';

interface IProps {
  activeStep: number;
  hasVideo?: boolean;
  docType: string;
  onBack: () => void;
  onNext: () => void;
}

const NavButtons = ({ activeStep, hasVideo = true, docType, onBack, onNext }: IProps) => {
  const { dirty, isValid, values, isSubmitting, handleSubmit, setSubmitting, errors } = useFormikContext<INewAccount>();
  const { imgsIds, bank_id, operation_id } = values;

  const onSubmit = () => {
    setSubmitting(true);
    handleSubmit();
  };

  const tooltipMessage = Object.values(errors)[0] || '';
  const caixaEconomicaId = '104';

  return (
    <div className='flex w-full flex-wrap items-center justify-end gap-2'>
      {activeStep > 0 && (
        <Button type='text' onClick={onBack} disabled={isSubmitting}>
          Voltar
        </Button>
      )}
      <Tooltip title={tooltipMessage as string} placement='top'>
        <div>
          {activeStep === 0 && (
            <Button
              type='primary'
              onClick={onNext}
              disabled={!dirty || !isValid || (bank_id === caixaEconomicaId && operation_id === 'not-selected')}
            >
              Próximo
            </Button>
          )}
          {activeStep === 1 && (
            <Button
              type='primary'
              onClick={onNext}
              loading={isSubmitting}
              disabled={
                (docType === PersonalDocumentType.CNH ? !imgsIds.imgDocCNH : !imgsIds.imgDocRG || !imgsIds.imgDocCPF) ||
                (hasVideo && !imgsIds.videoDoc) ||
                isSubmitting
              }
            >
              Próximo
            </Button>
          )}
          {activeStep === 2 && (
            <Button
              type='primary'
              onClick={onNext}
              loading={isSubmitting}
              disabled={!imgsIds.imgBankReceipt || isSubmitting}
            >
              Próximo
            </Button>
          )}
          {activeStep === 3 && (
            <Button type='primary' onClick={onSubmit} loading={isSubmitting} disabled={isSubmitting}>
              Finalizar
            </Button>
          )}
        </div>
      </Tooltip>
    </div>
  );
};

export default NavButtons;
